import { KeyboardEvent } from 'react';

export const onKeyDownIsEnter = (onEnter: () => void) => ({
  key,
}: KeyboardEvent<unknown>) => key === 'Enter' && onEnter();
